import { Prototype } from '../tree/prototype';
import { Aspect } from '../tree/aspect';
import { PrototypeTag } from './prototype-tag';

export class PrototypeModel {
    fields: PrototypeField[] = []; // use array instead of map for drag and drop order.
    map: Map<any, Aspect> = new Map<any, Aspect>();

    constructor(
        prototype?: Prototype | Aspect
    ) {
        if (prototype) {
            this.loadFields(prototype.data);
        }
    }

    load(...aspects: Aspect[]) {
        if (aspects?.length) {
            aspects.forEach(aspect => {
                if (aspect && !this.map.has(aspect._id)) {
                    this.loadFields(aspect.data);
                    this.map.set(aspect._id, aspect);
                }
            });
        }
    }

    clear() {
        this.fields = [];
        this.map.clear();
    }

    private loadFields(data: any) {
        const loaded: Record<string, boolean> = {};
        if (!!data) {
            for (const key in data) {
                if (data.hasOwnProperty(key) && !(key in loaded)) {
                    const value = data[key];
                    if (!value.tag) {
                        value.tag = PrototypeTag.default;
                    }
                    this.fields.push({key: key, value });
                    loaded[key] = true;
                }
            }
        }
        this.fields.sort((a, b) => a.value?.index && b.value?.index ? a.value?.index - b.value?.index : 0)
    }
}

export interface PrototypeField {
    key?: string;
    value?: any;
}
